module.exports = __webpack_public_path__ + "static/media/graph-zoom-in.08762e87.svg";